import { useContext } from 'react'
import { RoutePath } from 'lib/types'
import { CoreContext } from 'lib/core/resources/context'

export const usePath = (): RoutePath => {
  return useContext(CoreContext).path
}
